import { USERS_CATALOG } from '../../../../../../configs/systemCatalogIds';

const getParams = (item, controlConfig, remoteGroup, parent) => {
  const itemData = item.get('item');

  // params to make item clickable
  let params = {};
  if (controlConfig && controlConfig.get('type') === 'user') {
    params = {
      sectionId: '',
      catalogId: USERS_CATALOG,
      recordId: item.get('key'),
      title: item.get('text'),
    };
  } else if (itemData) {
    params = {
      sectionId: itemData.get('sectionId'),
      catalogId: itemData.get('catalogId'),
      recordId: itemData.get('recordId'),
      title: item.get('text'),
    };
  }

  // parent
  if (parent) {
    params.parent = parent;
  }
  
  return params;
};

export { getParams };
